module.exports = __webpack_public_path__ + "img/gift-clubfun-icon2.ac0b690c.png";